// PrivateRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import { isTokenValid } from '../utils/authUtils';

export function PrivateRoute({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const accessToken = localStorage.getItem('accessToken');

        // If token is valid, no need to refresh.
        if (isTokenValid(accessToken)) {
          setIsAuthenticated(true);
        } else {
          // Attempt to refresh
          const { data } = await axiosInstance.post('/auth/refresh');
          localStorage.setItem('accessToken', data.accessToken);
          setIsAuthenticated(true);
        }
      } catch (err) {
        console.error('Authentication failed:', err);
        // If refresh fails, remove invalid token
        localStorage.removeItem('accessToken');
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthentication();
  }, []);

  // While checking or refreshing, show loading indicator
  if (isLoading) return <div>Loading...</div>;

  // If we failed to authenticate, bounce user to login
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}
export function PublicRoute({ children }) {
  const accessToken = localStorage.getItem('accessToken');

  // If token is valid, the user shouldn't see a public page like login.
  if (isTokenValid(accessToken)) {
    return <Navigate to="/home" replace />;
  }

  // Otherwise, show the public component (Login, Signup, etc).
  return children;
}